export function formatAmount(amount) {
  const [nairaPart, koboPart] = Number(amount).toFixed(2).split(".");
  const nairaPaddedWithCommas = nairaPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${nairaPaddedWithCommas}.${koboPart}`;
}

export function formatMoneyMask(amount, useFormatAmount = true) {
  // Remove the Naira sign and extra space from money and remove all other monetary characters
  let str = amount.substring(2, amount.length).replace(/[,]+/g, "");
  return useFormatAmount ? formatAmount(str) : str;
}
